import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { App } from './App';
import './index.css';
// Side-effect import: a browser IIFE that binds itself to #bg-canvas and
// exposes window.StoneBG. Shared verbatim with the marketing site.
import '@stonelink/brand/background.js';

const container = document.getElementById('root');
if (!container) throw new Error('Missing #root element');

// A data-dense console does not want the full marketing-page light show.
window.StoneBG?.setIntensity(0.4);
window.StoneBG?.setSpeed(0.55);

createRoot(container).render(
  <StrictMode>
    <BrowserRouter basename={import.meta.env.BASE_URL}>
      <App />
    </BrowserRouter>
  </StrictMode>,
);
